import routes from "components/routing/routes";
import ScrollToTop from "components/routing/ScrollToTop";
import GlobalJsonLd from "components/seo/GlobalJsonLd";
import TagManager from "components/tracking/TagManager";
import Loading from "components/utils/loading/loading";
import { Component, Suspense } from "react";
import "./App.css";
import Footer from "./components/common/footer/footer";
import Header from "./components/common/header/header";
import AccentThemePicker from "./components/common/accent-theme-picker/accent-theme-picker";
import WhatsAppFloat from "./components/common/whatsapp-float/whatsapp-float";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

class App extends Component {
    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleBackToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    handleScroll = () => {
        const backToTop = document.querySelector(".back-to-top");
        if (backToTop) {
            if (
                document.body.scrollTop > 50 ||
                document.documentElement.scrollTop > 50
            ) {
                backToTop.style.display = "flex";
            } else {
                backToTop.style.display = "none";
            }
        }
    };

    render() {
        return (
            <Router>
                <ScrollToTop />
                <TagManager />
                <GlobalJsonLd />
                <div className="app">
                    <div className="header">
                        <Header />
                    </div>
                    <div className="content-wrapper">
                        <main className="main-content">
                            <Suspense fallback={<Loading />}>
                                <Routes>
                                    {routes.map((route) => (
                                        <Route
                                            key={route.path}
                                            path={route.path}
                                            element={route.element}
                                        />
                                    ))}
                                </Routes>
                            </Suspense>
                        </main>
                    </div>
                    <div className="footer">
                        <Footer />
                    </div>
                    <WhatsAppFloat />
                    <AccentThemePicker />
                    <button
                        type="button"
                        className="back-to-top"
                        aria-label="Back to top"
                        onClick={this.handleBackToTop}
                    >
                        <i className="lni lni-chevron-up" aria-hidden="true" />
                    </button>
                </div>
            </Router>
        );
    }
}

export default App;
